var _symbol, _symbol2, _symbol3, _symbol4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowsIconSprite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "to-top-right-tail-icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.26668 12L3.33334 11.0667L9.73334 4.66668H4.00001V3.33334H12V11.3333H10.6667V5.60001L4.26668 12Z",
    fill: "currentColor"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "double-filter-icon",
    viewBox: "0 0 18 18",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 11L12 6",
    stroke: "#898D9A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "0.2 0.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 7L6 12",
    stroke: "#898D9A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "0.2 0.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 7L12.8321 5.24807C12.4362 4.65434 11.5638 4.65434 11.1679 5.24808L10 7",
    stroke: "#898D9A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "0.2 0.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11L6.83205 12.7519C6.43623 13.3457 5.56377 13.3457 5.16795 12.7519L4 11",
    stroke: "#898D9A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "0.2 0.2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 16,
    height: 16,
    rx: 2.8,
    stroke: "#898D9A",
    strokeWidth: 1.5
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "once-filter-icon",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 16V8M12 16L9 13M12 16L15 13",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "arrow-select-icon",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99955 5.3325C7.84379 5.3322 7.69283 5.38645 7.57289 5.48583L4.23955 8.1525C4.10341 8.26566 4.01779 8.42827 4.00154 8.60455C3.98529 8.78084 4.03973 8.95636 4.15289 9.0925C4.26605 9.22865 4.42865 9.31426 4.60494 9.33051C4.78122 9.34677 4.95674 9.29233 5.09289 9.17917L7.99955 6.85917L10.9062 9.0725C10.9744 9.12788 11.0529 9.16923 11.1371 9.19419C11.2213 9.21914 11.3097 9.2272 11.397 9.21791C11.4844 9.20862 11.569 9.18215 11.6461 9.14004C11.7232 9.09792 11.7912 9.04099 11.8462 8.9725C11.9073 8.90395 11.9535 8.82354 11.982 8.73629C12.0106 8.64904 12.0208 8.55684 12.012 8.46546C12.0032 8.37409 11.9757 8.2855 11.9311 8.20527C11.8865 8.12503 11.8259 8.05486 11.7529 7.99917L8.41955 5.44583C8.29616 5.36216 8.14829 5.32225 7.99955 5.3325Z",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsIconSprite);
export default __webpack_public_path__ + "static/media/arrows-icon-sprite.2eb4cfdd666c987ad5b430755c75eebc.svg";
export { ForwardRef as ReactComponent };